/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeCachedMapImageListResponse,
  MapCacheGetImageParams,
  MapCacheListParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type mapCacheListResponse200 = {
  data: ApiEnvelopeCachedMapImageListResponse
  status: 200
}

export type mapCacheListResponse401 = {
  data: ApiEnvelopeCachedMapImageListResponse
  status: 401
}

export type mapCacheListResponse403 = {
  data: ApiEnvelopeCachedMapImageListResponse
  status: 403
}

export type mapCacheListResponseSuccess = (mapCacheListResponse200) & {
  headers: Headers;
};
export type mapCacheListResponseError = (mapCacheListResponse401 | mapCacheListResponse403) & {
  headers: Headers;
};

export type mapCacheListResponse = (mapCacheListResponseSuccess | mapCacheListResponseError)

export const getMapCacheListUrl = (params?: MapCacheListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mapcache?${stringifiedParams}` : `/api/mapcache`
}

export const useMapCacheListHook = (): (params?: MapCacheListParams, options?: RequestInit) => Promise<mapCacheListResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: MapCacheListParams, options?: RequestInit) => {

        return customFetcher(getMapCacheListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type mapCacheGetImageResponse200 = {
  data: Blob
  status: 200
}

export type mapCacheGetImageResponse404 = {
  data: Blob
  status: 404
}

export type mapCacheGetImageResponseSuccess = (mapCacheGetImageResponse200) & {
  headers: Headers;
};
export type mapCacheGetImageResponseError = (mapCacheGetImageResponse404) & {
  headers: Headers;
};

export type mapCacheGetImageResponse = (mapCacheGetImageResponseSuccess | mapCacheGetImageResponseError)

export const getMapCacheGetImageUrl = (map3: string,
    params?: MapCacheGetImageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/mapcache/${map3}/image.png?${stringifiedParams}` : `/api/mapcache/${map3}/image.png`
}

export const useMapCacheGetImageHook = (): (map3: string,
    params?: MapCacheGetImageParams, options?: RequestInit) => Promise<mapCacheGetImageResponse> => {

      const customFetcher = useSfetchMutator();
      return (map3: string,
    params?: MapCacheGetImageParams, options?: RequestInit) => {

        return customFetcher(getMapCacheGetImageUrl(map3,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


